import { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";

const DISMISS_KEY = "mineai_pwa_dismissed_at";
const COOLDOWN_DAYS = 14;

export default function PwaInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (dismissed) {
      const ms = Date.now() - Number(dismissed);
      if (ms < COOLDOWN_DAYS * 24 * 60 * 60 * 1000) return;
    }
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setShow(false);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => {});
    setDeferred(null);
    setShow(false);
  };

  if (!show || !deferred) return null;

  return (
    <div
      className="fixed bottom-24 left-4 right-4 sm:left-6 sm:right-auto z-40 mc-card p-4 sm:max-w-sm shadow-2xl print:hidden"
      data-testid="pwa-install-prompt"
    >
      <button
        onClick={dismiss}
        className="absolute top-2 right-2 text-[#4A5568] hover:text-[#0A1128]"
        aria-label="dismiss"
      >
        <X size={16} />
      </button>
      <div className="flex items-center gap-2">
        <DownloadSimple size={20} weight="duotone" className="text-[#3B5BDB]" />
        <p className="font-display text-lg text-[#0A1128]">Install Mine AI</p>
      </div>
      <p className="text-xs text-[#4A5568] mt-1 leading-relaxed">
        Add Mine AI to your home screen for one-tap access. No app store needed.
      </p>
      <button
        data-testid="pwa-install-btn"
        onClick={install}
        className="mt-3 w-full py-2.5 rounded-md bg-[#3B5BDB] text-white text-sm font-medium hover:bg-[#2F49AF] smooth"
      >
        Install
      </button>
    </div>
  );
}
